import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import * as React from "react";

import Link from "@khanacademy/wonder-blocks-link";

const strings = {
    resetChildPassword: () =>
        (
            <Trans>
                If you have a child account, your parent can reset your password
                at{" "}
                <Link href="/settings#child-accounts">
                    Settings &gt; Child Accounts
                </Link>
                .
            </Trans>
        ) as React.ReactNode,
    maxAttemptsPasswordReset: (): React.ReactNode => {
        return (
            <Trans>
                Sorry, you’ve attempted to reset your password too many times.
                Please{" "}
                <Link
                    href="https://khanacademy.zendesk.com/hc/requests/new"
                    target="_blank"
                >
                    contact support
                </Link>{" "}
                for help.
            </Trans>
        );
    },
    signup: () =>
        (
            <Trans>
                If you can't find your account, you can{" "}
                <Link href="/signup">sign up</Link> for a new one.
            </Trans>
        ) as React.ReactNode,
    passwordNotice: (minLength: number): string =>
        t`Passwords should be at least ${minLength} characters long and should contain a mixture of letters, numbers, and other characters.` as string,
    invalidPassword: (minLength: number): string =>
        t`Your password must be at least ${minLength} characters long.` as string,
} as const;

export default strings;
